import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { Navigate, redirect, useNavigate } from 'react-router-dom';
import { doc, getDoc } from "firebase/firestore";
import { myFirestore } from '../../config/MyFirebase';

import { useAppSelector, useAppDispatch } from '../../config/hooks'
import { setUser } from '../../config/userSlice'

import { getMessaging, onMessage } from "firebase/messaging";
import { onBackgroundMessage } from "firebase/messaging/sw";
import QRCode from 'react-qr-code';
import { Sign } from 'crypto';
import Footer from '../layouts/Footer';

export default function Login({ token }: { token: any }) {

    const user = useAppSelector((state) => state.user.user)
    const dispatch = useAppDispatch()

    const navigate = useNavigate();


    const [errorCode, setErrorCode] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const [showQrCode, setShowQrCode] = useState(true);

    const messaging = getMessaging();

    const [isLogging, setIsLogging] = useState(false);
    // onMessage(messaging, (payload) => {
    //     console.log('Login Message received. ', payload);
    //     // ...
    // });

    // onBackgroundMessage(messaging, (payload) => {
    //     console.log('Login Received background message ', payload);
    //     // Customize notification here
    //     const notificationTitle = 'Background Message Title';
    //     const notificationOptions = {
    //         body: 'Background Message body.',
    //         icon: '/firebase-logo.png'
    //     };

    //     // self.registration.showNotification(notificationTitle,
    //     //   notificationOptions);
    // });

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({

            email: Yup.string().email('Invalid email address').required('Enter an email'),
            password: Yup.string()
                .required('Enter a password'),
        }),
        onSubmit: values => {
            // alert(JSON.stringify(values, null, 2));
            console.log(values);
            setIsLogging(true);
            setIsLogging(true);
            console.log(isLogging);

            const auth = getAuth();
            signInWithEmailAndPassword(auth, values.email, values.password)
                .then(async (userCredential) => {
                    // Signed in 
                    const user = userCredential.user;
                    const userId = userCredential.user.uid;
                    console.log(userCredential);


                    //Get user data with her id
                    const docRef = doc(myFirestore, "users", userId);
                    const docSnap = await getDoc(docRef);

                    if (docSnap.exists()) {
                        console.log("Document data:", docSnap.data());

                        dispatch(setUser(docSnap.data()));
                        navigate('/dashboard');

                    } else {
                        // docSnap.data() will be undefined in this case
                        //JE DOIS METTRE LA LOGIQUE DE DECONNEXION SIGN OUT AVANT DE REDIRIGER VERS LE LOGIN
                        console.log("No such document!");
                        navigate('/');
                    }

                })
                .catch((error) => {
                    const newErrorCode = error.code;
                    const newErrorMessage = error.message;
                    setShowErrorMessage(true);
                    setErrorMessage(newErrorMessage);
                    setErrorCode(newErrorCode);

                    setTimeout(() => {
                        setShowErrorMessage(false);

                    }, 5000);
                    // console.log(errorMessage);
                    // console.log(errorCode);
                });

            setIsLogging(false);



        },
    });

    return (
        <div className="login-page">

            <div className="login-logo">
                <a href="../../index2.html"><b>Copy&</b>Paste</a>
            </div>
            <div className="card">

                <div className="card-body login-card-body">

                    <div className="row">
                        <div className={showQrCode ? "col-md-7" : "col-md-12"}>

                            <p className="login-box-msg">Sign in to start your session</p>

                            {errorMessage && showErrorMessage ? (<div className='alert alert-danger'>{errorMessage}</div>) : null}

                            <form onSubmit={formik.handleSubmit}>
                                <div className="input-group mb-3">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.email}
                                        className={formik.touched.email && formik.errors.email ? ('form-control cp-is-invalid') : "form-control"}
                                        placeholder="Email"

                                    />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-envelope"></span>
                                        </div>
                                    </div>
                                    {formik.touched.email && formik.errors.email ? (
                                        <div id="" className="error invalid-feedback">{formik.errors.email}</div>
                                    ) : null}

                                </div>
                                <div className="input-group mb-3">
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.password}
                                        className={formik.touched.password && formik.errors.password ? ('form-control cp-is-invalid') : "form-control"}
                                        placeholder="Password" />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-lock"></span>
                                        </div>
                                    </div>
                                    {formik.touched.password && formik.errors.password ? (
                                        <div id="" className="error invalid-feedback">{formik.errors.password}</div>
                                    ) : null}
                                </div>
                                <div className="row justify-content-center">
                                    {/* <div className="col-8">
                                        <div className="icheck-primary">
                                            <input type="checkbox" id="remember" />
                                            <label htmlFor="remember">
                                                Remember Me
                                            </label>
                                        </div>
                                    </div> */}
                                    <div className="col-4">
                                        <button type="submit" className="btn btn-primary btn-block">

                                            {
                                                !isLogging

                                                    ? "Sign In" :

                                                    (<span className="spinner-border text-light" role="status">
                                                        {/* <span className="visually-hidden">Loading...</span> */}
                                                    </span>)


                                            }


                                        </button>
                                        {/* <a href='/dashboard/home' className="btn btn-primary btn-block">Sign In</a> */}
                                    </div>
                                </div>
                            </form>

                            <div className="social-auth-links text-center mb-3">
                                <p>- OR -</p>
                                {/* <a href="#" className="btn btn-block btn-primary">
                                    <i className="fab fa-facebook mr-2"></i> Sign in using Facebook
                                </a> */}
                                <a href="#" onClick={() => setShowQrCode(!showQrCode)} className="btn btn-block btn-primary">
                                    <i className="fas fa-mobile-alt mr-2"></i> Sign in using connected device
                                </a>
                                {/* <a href="#" className="btn btn-block btn-danger">
                                    <i className="fab fa-google-plus mr-2"></i> Sign in using Google
                                </a> */}
                            </div>

                            {/* <p className="mb-1">
                                <a href="forgot-password.html">I forgot my password</a>
                            </p> */}
                            <p className="mb-0">
                                <a href="/register" className="text-center">
                                    Register a new membership

                                </a>
                            </p>

                        </div>

                        {showQrCode ?

                            (<div className="col-md-5">

                                <div style={{ marginTop: "20%", padding: "20px" }} className="row align-center justify-content-center">


                                    {
                                        !isLogging

                                            ? (<QRCode value={token} />) :

                                            (<span className="spinner-border text-light" role="status">
                                                {/* <span className="visually-hidden">Loading...</span> */}
                                            </span>)


                                    }



                                </div>

                            </div>)

                            : null
                        }
                    </div>

                </div>


            </div>
            <div className="mt-5">
                <strong>Copyright &copy; 2024 <a href="https://httpswebcopypaste">Copy&Paste</a>.</strong>
                All rights reserved.
                <div className="float-right d-none d-sm-inline-block">
                    {/* <b>Version</b> 1.0.0 */}
                </div>
            </div>

        </div>
    )
}
